import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "item articleResult" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "preview" }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  key: 0,
  class: "tag"
}
const _hoisted_10 = { class: "heading" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "articleDetails" }
const _hoisted_13 = {
  key: 0,
  class: "avatar"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "details" }
const _hoisted_16 = {
  key: 0,
  class: "name"
}
const _hoisted_17 = { class: "dateTime" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.result.url,
      class: "card"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("picture", null, [
          _createElementVNode("source", {
            srcset: 
              _ctx.isPreviewItem
                ? _ctx.result?.images?.previewImage?.url.toCropUrl(420, 460) ||
                  _ctx.defaultSiteImageUrl.toCropUrl(420, 460)
                : _ctx.result?.images?.previewImage?.url.toCropUrl(420, 460) ||
                  _ctx.defaultSiteImageUrl.toCropUrl(420, 460)
            ,
            media: "(min-width: 1050px)"
          }, null, 8, _hoisted_4),
          _createElementVNode("source", {
            srcset: 
              _ctx.result?.images?.previewImage?.url.toCropUrl(450, 430) ||
                _ctx.defaultSiteImageUrl.toCropUrl(450, 430)
            ,
            media: "(min-width: 500px)"
          }, null, 8, _hoisted_5),
          _createElementVNode("source", {
            srcset: 
              _ctx.result?.images?.previewImage?.url.toCropUrl(210, 230) ||
                _ctx.defaultSiteImageUrl.toCropUrl(210, 230)
            ,
            media: "(min-width: 0px)"
          }, null, 8, _hoisted_6),
          _createElementVNode("img", {
            src: 
              _ctx.isPreviewItem
                ? _ctx.result?.images?.previewImage?.url.toCropUrl(210, 230) ||
                  _ctx.defaultSiteImageUrl.toCropUrl(210, 230)
                : _ctx.result?.images?.previewImage?.url.toCropUrl(210, 230) ||
                  _ctx.defaultSiteImageUrl.toCropUrl(210, 230)
            ,
            alt: _ctx.result?.images?.previewImage?.altText
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.result?.additionalFields.previewTag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.result?.additionalFields.previewTag), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.result?.additionalFields.previewTitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.result?.additionalFields.previewTitle), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.result?.additionalFields.authorImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _ctx.result?.additionalFields.authorImage,
                  alt: "author portrait"
                }, null, 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.result?.additionalFields.authorName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.result?.additionalFields.authorName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_17, [
              (_ctx.result?.additionalFields.displayDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.result?.additionalFields.displayDate), 1))
                : _createCommentVNode("", true),
              (_ctx.result?.additionalFields.readTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.result?.additionalFields.readTime), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ]))
}